<template>
  <div class="search-container">
    <el-form ref="form" inline>
      <el-form-item label="门店" label-width="80px">
        <el-select v-model="queryParam.factorySn" clearable filterable remote :remote-method="getShops" :loading="loading" placeholder="输入门店名称搜索">
          <el-option v-for="shop in shops" :key="shop.sn" :label="shop.companyName" :value="shop.sn"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="运营老师" label-width="80px" v-if="$permission.hasAuth([4, 8, 11])">
        <el-select v-model="queryParam.generalServiceSn" clearable>
          <el-option v-for="service in services" :key="service.sn" :label="service.name" :value="service.sn"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时间" label-width="80px">
        <el-date-picker
            v-model="dateRange"
            type="daterange"
            value-format="YYYY-MM-DD"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="截止时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="状态" label-width="80px">
        <el-radio v-model="queryParam.douyinLinkStatus" label="">所有</el-radio>
        <el-radio v-model="queryParam.douyinLinkStatus" :label="true">已完成</el-radio>
        <el-radio v-model="queryParam.douyinLinkStatus" :label="false">未完成</el-radio>
      </el-form-item>
      <el-form-item label-width="0">
        <el-button type="primary" @click="list(1)">
          <el-icon><search /></el-icon>查询
        </el-button>
      </el-form-item>
    </el-form>
  </div>
  <div class="table-container">
    <div class="table-header">
      <el-row :gutter="10">
        <el-col :span="10">
          <div class="table-title"><span></span>拍摄任务列表</div>
        </el-col>
        <el-col :span="14">
          <div class="table-button-container"></div>
        </el-col>
      </el-row>
    </div>
    <el-table :data="tasks" border>
      <el-table-column prop="publishDate" label="日期"></el-table-column>
      <el-table-column v-if="$permission.hasAuth([4, 8, 11])" prop="generalServiceName" label="运营老师"></el-table-column>
      <el-table-column prop="factoryCompanyName" label="门店"></el-table-column>
      <el-table-column label="状态">
        <template #default="scope">
          <el-tag v-if="scope.row.douyinLinkStatus" type="success">已完成</el-tag>
          <el-tag v-else type="info">未完成</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="链接">
        <template #default="scope">
          <el-link v-if="scope.row.douyinLinkStatus" :href="scope.row.douyinLink" target="_blank">预览</el-link>
        </template>
      </el-table-column>
      <el-table-column label="脚本">
        <template #default="scope">
          <el-popover placement="left-start" :width="280" trigger="hover"
                      v-for="(script, index) in scope.row.douyinScriptVOS" :key="script.douyinScriptSn" :title="'脚本' + (index + 1)">
            <template #reference>
              <el-link href="javascript:;" type="primary">{{'脚本' + (index + 1)}}</el-link>
            </template>
            <div>{{'标题：' + script.title}}</div>
            <div>{{'封面：' + script.cover}}</div>
            <div>{{'场景：' + script.scene}}</div>
            <div>{{'话术：' + script.content}}</div>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @current-change="handleCurrentChange" v-model:current-page="pageIndex" @size-change="handleSizeChange"
                   :page-size="pageSize" :total="total" :page-sizes="pageSizes" :pager-count="5"
                   background
                   layout="sizes, prev, pager, next, total"></el-pagination>
  </div>
</template>

<script>
export default {
  name: "短视频运营",
  props: {
    currentUser: {
      type: Object
    }
  },
  data() {
    return {
      pageSizes: [10, 20, 50],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      queryParam: {},
      dateRange: [],
      tasks: [],
      loading: false,
      shops: [],
      services: []
    }
  },
  methods: {
    list(pageIndex) {
      if (pageIndex) {
        this.pageIndex = pageIndex
      }
      if (this.dateRange) {
        this.queryParam.publishStartDate = this.dateRange[0]
        this.queryParam.publishEndDate = this.dateRange[1]
      } else {
        this.queryParam.publishStartDate = null
        this.queryParam.publishEndDate = null
      }
      this.$utils.deleteEmptyProperty(this.queryParam)
      this.queryParam.pageIndex = this.pageIndex - 1
      this.queryParam.pageSize = this.pageSize
      this.$apis.operationService.list(this.queryParam).then(response => {
        this.tasks = response.data.data
        this.total = response.data.total
      })
    },
    handleCurrentChange(pageIndex) {
      this.pageIndex = pageIndex
      this.list()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.list(1)
    },
    getShops(str) {
      if (str !== '') {
        this.loading = true
        let param = {companyName: str}
        this.$apis.shopMgr.list(0, 15, param).then(response => {
          this.shops = response.data.data
          this.loading = false
        })
      } else {
        this.shop = []
      }
    }
  },
  created() {
    if (this.currentUser.type === 10) {
      this.queryParam.generalServiceSn = this.currentUser.sn
    } else {
      this.$apis.common.userList(0, 99, {type: 10}).then(response => {
        this.services = response.data.data
      })
    }
    const date = new Date()
    this.dateRange = [this.$utils.dateFormat(date) , this.$utils.dateFormat(new Date())]
    this.list()
  }
}
</script>

<style scoped>

</style>